import { spawn } from 'redux-saga/effects';

import { watchCreateTicket } from './createTicket';

export default function* saga() {
  yield spawn(watchCreateTicket);
}
